"use client";

import { GeramaLogo } from "@gerama/ui";

export const OTP_LENGTH = 5;
export const RESEND_SECONDS = 45;

export function toLatinDigits(value: string): string {
  return value
    .replace(/[۰-۹]/g, (digit) => String("۰۱۲۳۴۵۶۷۸۹".indexOf(digit)))
    .replace(/[٠-٩]/g, (digit) => String("٠١٢٣٤٥٦٧٨٩".indexOf(digit)));
}

export function maskMobile(mobile: string): string {
  const digits = toLatinDigits(mobile).replace(/\D/g, "");
  if (digits.length < 6) return digits;
  return `${digits.slice(0, 2)} *** *** ${digits.slice(-4)}`;
}

/** Iranian mobile as typed: 11 digits starting with 09. A 10-digit 9… is prefixed. */
export function normalizeMobileInput(value: string): string {
  const raw = toLatinDigits(value).replace(/\D/g, "").slice(0, 11);
  if (raw.length === 10 && raw.startsWith("9")) return `0${raw}`;
  return raw;
}

export function isMobileValid(value: string): boolean {
  return /^09\d{9}$/.test(value);
}

export function AuthLogo() {
  return (
    <div className="flex w-full items-center justify-center">
      <GeramaLogo className="h-14" />
    </div>
  );
}

export function OrDivider() {
  return (
    <div className="relative my-6 flex items-center justify-center gap-3">
      <div className="bg-border h-px flex-1" />
      <span className="text-muted-foreground text-sm">یا</span>
      <div className="bg-border h-px flex-1" />
    </div>
  );
}

export function FormError({ message }: { message?: string }) {
  if (!message) return null;
  return (
    <p className="text-destructive mb-3 text-sm" role="alert">
      {message}
    </p>
  );
}
